import { Link } from "react-router-dom";
import { ROUTES } from "../Routes";

function Hero() {
  return (
    <section className="hero">
      <h1>🎮 PLAY SAFE, PLAY SMART! 🎮</h1>
      <p>Experience the thrill of social casino games without risking real money</p>
      <Link to={ROUTES.GAMES} className="cta-button">EXPLORE GAMES</Link>
    </section>
  );
}

export default Hero;